<template>
<f7-page>
  <f7-navbar title="Right Panel"></f7-navbar>

  <f7-block-title>Parts in current steps</f7-block-title>
  <f7-list>
    <f7-list-item v-for="(item,key) in currentStepListItem" :title="item" :key="key"></f7-list-item>
  </f7-list>
  
</f7-page>
</template>
<script>
import {serverBus} from '../main';

export default {
  data: function() {
    return {
      currentStepListItem: []
    }
  },
  created: function() {

    serverBus.$on('stepChangeFinish', (listItem) => {
      console.log('stepchange finish', listItem)
      this.currentStepListItem = listItem;
    });


  }

}
</script>



// WEBPACK FOOTER //
// src/partial/panel-right.vue